/* eslint-disable react/require-default-props */
function Facebook({
  color = '#1877F2',
  backgroundColor = '#fff',
  height = '24',
  width = '25',
}: {
  color?: string;
  backgroundColor?: string;
  height?: string;
  width?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_752_2679)">
        <path
          d="M24.333 12C24.333 5.37258 18.9604 0 12.333 0C5.70559 0 0.333008 5.37258 0.333008 12C0.333008 17.9895 4.72121 22.954 10.458 23.8542V15.4688H7.41113V12H10.458V9.35625C10.458 6.34875 12.2496 4.6875 14.9906 4.6875C16.3031 4.6875 17.6768 4.92188 17.6768 4.92188V7.875H16.1636C14.673 7.875 14.208 8.80008 14.208 9.75V12H17.5361L17.0041 15.4688H14.208V23.8542C19.9448 22.954 24.333 17.9895 24.333 12Z"
          fill={color}
        />
        <path
          d="M17.0041 15.4688L17.5361 12H14.208V9.75C14.208 8.80102 14.673 7.875 16.1636 7.875H17.6768V4.92188C17.6768 4.92188 16.3036 4.6875 14.9906 4.6875C12.2496 4.6875 10.458 6.34875 10.458 9.35625V12H7.41113V15.4688H10.458V23.8542C11.7005 24.0486 12.9656 24.0486 14.208 23.8542V15.4688H17.0041Z"
          fill={backgroundColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_752_2679">
          <rect
            width={height}
            height={height}
            fill={backgroundColor}
            transform="translate(0.333008)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Facebook;
